
window.addEventListener('DOMContentLoaded', async function () {
    const customerID = $("#bodyTheme")[0].dataset.gtmUserData;
    
    if (!customerID) {
      const eventUserGuest = new CustomEvent("gtm-datalayer",{
        detail: {
          path: 'global:userGuest',
          custom: {
            'loggedInState': `${!!customerID}`,
            'registered': `${!!customerID}`
          }
        }
      });
      document.dispatchEvent(eventUserGuest);
      return;
    }
    const eventUserLogged = new CustomEvent("gtm-datalayer",{
      detail: {
        path: 'global:userLogged',
        custom: {
          'loggedInState': !!customerID,
          'user_id': customerID || ''              
        }
      }
    });
    document.dispatchEvent(eventUserLogged);
});

function GoogleTagManagerHelpers() {
    const types = {
        icon: 'icon',
        button: 'button',
        card: 'card',
        field: 'field',
        filter: 'filter',
        search: 'search',
        header: 'header',
        menu: 'menu',
        tags: {
            span: 'text',
            button: 'button',
            i: 'icon',
            svg: 'icon',
            path: 'icon',
            img: 'card'
        } 
    }

    const pageCodes = {
        products: 'pdp',
        collections: 'plp',
        search: 'search',
        home: 'home'
    }

    const locationPathName = {
        pdp: () => `pdp:${window.product.handle}`,
        plp: () => `plp:${window.location.pathname.substring(1).replace(/\//g, '-')}`,
        search: () => `search:${new URL(window.location.href).searchParams.get('q').replace(/\s/g, '-')}`,
        home: () => `home`
    }

    const getLocationPathname = () => {
        const pagePath = window.location.pathname.substring(1).split('/')[0];
        const pageCode = pagePath ? pageCodes[pagePath] : pageCodes['home'];
        return locationPathName[pageCode] ? locationPathName[pageCode]() : pagePath;
    }

    const formatString = (str) => {
        return str && typeof str === 'string' ? str.toLowerCase().trim().normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/\s\s+/g, ' ').replace(/[\s-\_-\/]/g, '-').replace(/[^a-zA-Z0-9-\-]/g, '').replace(/^-+|-+$/g, '').replace(/-+/g, '-') : '';
    }

    const formatProductTitle = (productTItle) => {
        return productTItle ? productTItle.split('/').map((option) => option.trim().replace(/\s\s+/g, ' ').replace(/[\s-\_]/g, '-')).join('-').toLowerCase().replace(/[^a-zA-Z0-9-\-]/g, '').replace(/-+/g, '-') : '';
    }

    const convertPrice = (price) => {
        const priceDecimal = price / 100;
        return priceDecimal.toFixed(2);
    }

    const productItemByProductAndVariant = (product, productVariant) => {
        return ({
            item_name: formatString(product.title),
            item_id: productVariant.sku || undefined,
            item_brand: 'havaianas',
            item_category: formatString(product.type) || undefined,
            item_variant: formatProductTitle(productVariant.title) || undefined,
            price: convertPrice(productVariant.price)
        });
    }
    const productItemByProductCard = (productCard) => {
        const product = {
            title: productCard.dataset.productTitle,
            type: productCard.dataset.productType
        }
        const productVariant = {
            sku: productCard.dataset.productVariantSku,
            title: productCard.dataset.productVariantTitle,
            price: productCard.dataset.productVariantPrice
        }
        return productItemByProductAndVariant(product, productVariant);
    }

    const lineItemsExtractProductList = (lineItems) => {
        let productItems = [];
        if (lineItems && lineItems.length > 0) {
          productItems = lineItems.map((lineItem) => ({
            item_id: lineItem.sku || undefined,
            item_name: formatString(lineItem.product_title) || undefined,
            item_category: formatString(lineItem.product_type) || undefined,
            item_brand: 'havaianas',
            item_variant: formatProductTitle(lineItem.variant_title) || undefined, 
            quantity: lineItem.quantity,
            price: convertPrice(lineItem.price),
            currency: 'USD'
          }));
        }
        return productItems;
    }
    const isElementOnScreen = (element) => {
        const boundingClientRect = element.getBoundingClientRect();
        if(boundingClientRect.top==0 && boundingClientRect.left==0 && boundingClientRect.right==0 && boundingClientRect.bottom==0){
            return false
        }else{
            return true;
        }
        
    }
    return ({
        types,
        getLocationPathname,
        formatString,
        formatProductTitle,
        convertPrice,
        productItemByProductAndVariant,
        lineItemsExtractProductList,
        isElementOnScreen,
        productItemByProductCard
    });
};

function GoogleTagManagerDatalayer() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayerIntervalList = [];
    const gtmHelpers = new GoogleTagManagerHelpers();

    const GTM_EVENTS = {
        default: {
            'event': null,
            'event_type': 'event_custom',
            'custom_section': null,
            'custom_type': null,
            'custom_title': null,
        },
        enhancedEcommerce: {
            'event': null,
            'event_type': 'event_ecomm_recommended',
            'ecommerce': {
                'currency' : 'USD',
                'value': null,
                'items': []
            }
        },
        enhancedEcommerceContentSlot: {
            'event': null,
            'event_type': 'event_ecomm_recommended',
            'ecommerce': {
                'items': []
            }
        }
    }
    
    const GTM_EVENTS_CONFIG = {
        general: {
            interact: {
                ...GTM_EVENTS.default,
                'event': 'interact',
            },
            click: {
                ...GTM_EVENTS.default,
                'event': 'click',
            },
            fillForm: {
                ...GTM_EVENTS.default,
                'event': 'fillForm',
            },
            callback: {
                'event': 'callback',
                'event_type': 'event_custom',
                'custom_section': null,
                'custom_type': null,
                'custom_typeError': null
            },
        },
        global: {
            userGuest: {
                'event':'global',
                'loggedInState': null,
                'currencyCode':'USD',
                'registered': null
            },
            userLogged: {
                'event': 'global',
                'loggedInState': null,
                'currencyCode':'USD',
                'user_id': null,
            }
        },
        pdp: {
            productAvaialbility: {
                ...GTM_EVENTS.default,
                'event':'productAvaialbility',
                'custom_city': null,
                'custom_state': null,
            },
            productsUnavailable: {
                'event':'productsUnavailable:false',
                'custom_section': null,
                'custom_title': null,
                'custom_stock': null,
            }
        },
        enhancedEcommerce: {
            removeFromCart: {
                ...GTM_EVENTS.enhancedEcommerce,
                'event': 'remove_from_cart',
            },
            addToCart: {
                ...GTM_EVENTS.enhancedEcommerce,
                'event': 'add_to_cart',
            },
            viewItem: {
                ...GTM_EVENTS.enhancedEcommerce,
                'event': 'view_item'
            },
            viewCart: {  
                ...GTM_EVENTS.enhancedEcommerce,
                'event': 'view_cart'
            },
            viewPromotion: {
                ...GTM_EVENTS.enhancedEcommerceContentSlot,
                'event': 'view_promotion'
            },
            selectPromotion: {
                ...GTM_EVENTS.enhancedEcommerceContentSlot,
                'event': 'select_promotion'
            },
            viewItemList: {
                ...GTM_EVENTS.enhancedEcommerce,
                'event': 'view_item_list'
            },
            selectItem: {
                ...GTM_EVENTS.enhancedEcommerce,
                'event': 'select_item',
            }
        },
    }

    const sanitizeGTMData = (config, object) => {
        const configSanitized = { ...config };
        Object.keys(config).forEach((key) => {
            if (object[key]) {
                configSanitized[key] = object[key] !== '' && object[key] !== null ? object[key] : undefined;
            }
        });
        Object.keys(configSanitized).forEach((key) => {
            if (configSanitized[key] === null) {
                configSanitized[key] = undefined;
            }
        });
        return configSanitized;
    }
    const getLocation = (e) => {
        if(e.currentTarget.offsetParent && e.currentTarget.offsetParent.className && e.currentTarget.offsetParent.className=="mega-menu-content"){
            return "menu"
        }
        if($(e.currentTarget).closest("header").length>0){
            return "header"
        }
        if($(e.currentTarget).closest("footer").length>0){
            return "footer"
        }
        return "body"
 
    }
    const listenAnchorButtonClick = () => {
        $(document).on('click touchstart', 'a, button', function (e) {
            if ($(this).data('gtmClickCancel')) return;
            let title = $(this).data('gtmTitle') ? $(this).data('gtmTitle') : `${$(this).text()}`
            const type = $(this).data('gtmTypeTag') ? $(this).data('gtmTypeTag') : e.target.tagName.toLowerCase();
            let customType;
            let hasTitle = title.replace(/\s/g, '');
            let customName = getLocation(e);
            if(customName==="body"){
                customType = gtmHelpers.types.tags[type] || 'link';
            }else{
                customType = customName;
            }
            if (customType === 'inherit') {
                customType = gtmHelpers.types.tags[this.tagName.toLowerCase()] || 'link';
            }
            
            if (!hasTitle && customType === gtmHelpers.types.card && e.target.alt) {
                title = e.target.alt;
                hasTitle = title.replace(/\s/g, '');
            } else if (!hasTitle && this.ariaLabel) {
                title = this.ariaLabel;
            }

            title = gtmHelpers.formatString(title);

            $(document).trigger('gtm-datalayer', {
                path: 'general:click',
                custom: {
                    custom_type: customType,
                    custom_title: title
                }
            });
        });
    }

    const gtmIntervalProcess = () => {
        setInterval(() => {
            
            if (window.dataLayerIntervalList && window.dataLayerIntervalList.length > 0) {
                window.dataLayerIntervalList.forEach((process, index) => {
                    if (typeof process === "function") {
                        const result = process();
                        
                        if (result.ok && (result.once || result.stop)) {
                            window.dataLayerIntervalList[index] = null;
                        }
                    }
                });
            }
        }, 1000);
    }

    const startListen = () => {
        $(document).on('gtm-datalayer', function (event, dataEvent) {
            const data = event.detail || dataEvent;
            const type = data.path.split(':')[0];
            const action = data.path.split(':')[1];
            if (!data.custom.custom_section) {
                data.custom.custom_section = gtmHelpers.getLocationPathname();
            }
            if (GTM_EVENTS_CONFIG[type] && GTM_EVENTS_CONFIG[type][action]) {
                const gtmData = sanitizeGTMData(GTM_EVENTS_CONFIG[type][action], data.custom);
                window.dataLayer.push(gtmData);
                /* console.log("GTM-PUSHED") */
            }
        });

        listenAnchorButtonClick();
        gtmIntervalProcess();
    }

    return ({
        startListen,
    });
}

const gtm = new GoogleTagManagerDatalayer();
gtm.startListen();